(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["malvice-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeReviews(reviewsSection) {
      if (reviewsSection.hasAttribute('data-malvice-reviews-ready')) return;

      var viewport = reviewsSection.querySelector('[data-malvice-reviews-viewport]');
      var track = reviewsSection.querySelector('[data-malvice-reviews-track]');
      var previous = reviewsSection.querySelector('[data-malvice-reviews-previous]');
      var next = reviewsSection.querySelector('[data-malvice-reviews-next]');
      var originalCards = track ? Array.prototype.slice.call(track.querySelectorAll('.malvice-product-review')) : [];

      if (!viewport || !track || !previous || !next || originalCards.length < 2) return;

      reviewsSection.setAttribute('data-malvice-reviews-ready', '');

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var designMode = Boolean(window.Shopify && window.Shopify.designMode);
      var clones = [];
      var leadingClones = [];
      var trailingClones = [];
      var moveQueue = [];
      var loopWidth = 0;
      var animationFrame = 0;
      var manualAnimationFrame = 0;
      var manualAnimationStart = 0;
      var manualStartPosition = 0;
      var manualTargetPosition = 0;
      var normalizationFrame = 0;
      var resumeTimer = 0;
      var scrollEndTimer = 0;
      var lastFrameTime = 0;
      var autoplayCarry = 0;
      var isVisible = false;
      var isHovered = false;
      var isFocused = false;
      var isPointerDown = false;
      var isManuallyPaused = false;
      var isManualScrolling = false;
      var isNormalizing = false;
      var keyboardInteraction = false;
      var resizeObserver;
      var visibilityObserver;

      function createClone(card) {
        var clone = card.cloneNode(true);
        var cloneElements = [clone].concat(Array.prototype.slice.call(clone.querySelectorAll('*')));

        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');

        cloneElements.forEach(function (element) {
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
        });

        clones.push(clone);
        return clone;
      }

      var leadingFragment = document.createDocumentFragment();
      var trailingFragment = document.createDocumentFragment();

      originalCards.forEach(function (card) {
        var leadingClone = createClone(card);
        leadingClones.push(leadingClone);
        leadingFragment.appendChild(leadingClone);
      });

      originalCards.forEach(function (card) {
        var trailingClone = createClone(card);
        trailingClones.push(trailingClone);
        trailingFragment.appendChild(trailingClone);
      });

      track.insertBefore(leadingFragment, originalCards[0]);
      track.appendChild(trailingFragment);

      previous.disabled = false;
      next.disabled = false;

      function cardStep() {
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 8;
        return originalCards[0].getBoundingClientRect().width + gap;
      }

      function positiveModulo(value, divisor) {
        return ((value % divisor) + divisor) % divisor;
      }

      function setScrollLeftSilently(value) {
        if (Math.abs(viewport.scrollLeft - value) < 0.5) return;

        isNormalizing = true;
        viewport.scrollLeft = value;
        window.cancelAnimationFrame(normalizationFrame);
        normalizationFrame = window.requestAnimationFrame(function () {
          isNormalizing = false;
          normalizationFrame = 0;
        });
      }

      function measureLoop() {
        var cancelledManualMove = isManualScrolling;

        if (isManualScrolling) {
          window.cancelAnimationFrame(manualAnimationFrame);
          manualAnimationFrame = 0;
          isManualScrolling = false;
          moveQueue.length = 0;
          viewport.classList.remove('is-manual-moving');
        }

        var previousLoopWidth = loopWidth;
        var previousProgress = previousLoopWidth > 0
          ? positiveModulo(viewport.scrollLeft, previousLoopWidth) / previousLoopWidth
          : 0;

        loopWidth = trailingClones[0].offsetLeft - originalCards[0].offsetLeft;

        if (loopWidth <= 0) {
          loopWidth = track.scrollWidth / 3;
        }

        if (loopWidth > 0) {
          setScrollLeftSilently(loopWidth + previousProgress * loopWidth);
        }

        if (cancelledManualMove) startAnimation();
      }

      function normalizeLoopPosition() {
        if (loopWidth <= 0) return;

        var normalizedPosition = loopWidth + positiveModulo(viewport.scrollLeft, loopWidth);
        setScrollLeftSilently(normalizedPosition);
      }

      function normalizeOuterBand() {
        if (loopWidth <= 0 || isManualScrolling) return;

        if (viewport.scrollLeft < loopWidth * 0.75) {
          setScrollLeftSilently(viewport.scrollLeft + loopWidth);
        } else if (viewport.scrollLeft >= loopWidth * 2.2) {
          setScrollLeftSilently(viewport.scrollLeft - loopWidth);
        }
      }

      function canAnimate() {
        return !designMode
          && !reducedMotion.matches
          && !document.hidden
          && isVisible
          && !isHovered
          && !isFocused
          && !isPointerDown
          && !isManuallyPaused
          && !isManualScrolling
          && loopWidth > 0;
      }

      function stopAnimation() {
        if (animationFrame) {
          window.cancelAnimationFrame(animationFrame);
          animationFrame = 0;
        }

        lastFrameTime = 0;
        autoplayCarry = 0;
        viewport.classList.remove('is-autoplaying');
      }

      function animate(timestamp) {
        if (!canAnimate()) {
          stopAnimation();
          return;
        }

        if (!lastFrameTime) {
          lastFrameTime = timestamp;
        }

        var elapsed = Math.min(timestamp - lastFrameTime, 64);
        autoplayCarry += 34 * elapsed / 1000;
        var advance = Math.floor(autoplayCarry);
        if (advance > 0) {
          viewport.scrollLeft += advance;
          autoplayCarry -= advance;
          normalizeLoopPosition();
        }

        lastFrameTime = timestamp;
        animationFrame = window.requestAnimationFrame(animate);
      }

      function startAnimation() {
        if (!canAnimate() || animationFrame) return;

        viewport.classList.add('is-autoplaying');
        lastFrameTime = 0;
        animationFrame = window.requestAnimationFrame(animate);
      }

      function pauseTemporarily(delay) {
        isManuallyPaused = true;
        window.clearTimeout(resumeTimer);
        stopAnimation();

        resumeTimer = window.setTimeout(function () {
          isManuallyPaused = false;
          startAnimation();
        }, delay);
      }

      function scheduleScrollEnd(delay) {
        window.clearTimeout(scrollEndTimer);
        scrollEndTimer = window.setTimeout(finishUserScroll, delay || 180);
      }

      function finishManualMove() {
        window.cancelAnimationFrame(manualAnimationFrame);
        manualAnimationFrame = 0;
        viewport.scrollLeft = manualTargetPosition;
        normalizeLoopPosition();
        isManualScrolling = false;

        if (moveQueue.length > 0) {
          window.requestAnimationFrame(processMoveQueue);
        } else {
          viewport.classList.remove('is-manual-moving');
          startAnimation();
        }
      }

      function animateManualMove(timestamp) {
        if (!isManualScrolling) return;

        if (!manualAnimationStart) {
          manualAnimationStart = timestamp;
        }

        var progress = Math.min((timestamp - manualAnimationStart) / 320, 1);
        var easedProgress = 1 - Math.pow(1 - progress, 3);
        viewport.scrollLeft = manualStartPosition
          + (manualTargetPosition - manualStartPosition) * easedProgress;

        if (progress < 1) {
          manualAnimationFrame = window.requestAnimationFrame(animateManualMove);
        } else {
          finishManualMove();
        }
      }

      function processMoveQueue() {
        if (isManualScrolling || moveQueue.length === 0) {
          if (!isManualScrolling) startAnimation();
          return;
        }

        var direction = moveQueue.shift();
        normalizeLoopPosition();
        isManualScrolling = true;
        viewport.classList.add('is-manual-moving');
        manualAnimationStart = 0;
        manualStartPosition = viewport.scrollLeft;
        manualTargetPosition = manualStartPosition + cardStep() * direction;

        if (reducedMotion.matches) {
          viewport.scrollLeft = manualTargetPosition;
          window.requestAnimationFrame(finishManualMove);
        } else {
          manualAnimationFrame = window.requestAnimationFrame(animateManualMove);
        }
      }

      function finishUserScroll() {
        if (isManualScrolling) return;

        window.clearTimeout(scrollEndTimer);
        normalizeLoopPosition();
        startAnimation();
      }

      function move(direction) {
        pauseTemporarily(2600);
        moveQueue.push(direction < 0 ? -1 : 1);
        processMoveQueue();
      }

      function handleScroll() {
        if (isNormalizing || isManualScrolling || viewport.classList.contains('is-autoplaying')) return;

        normalizeOuterBand();
        scheduleScrollEnd(180);
      }

      function handleScrollEnd() {
        if (isNormalizing || isManualScrolling || viewport.classList.contains('is-autoplaying')) return;
        finishUserScroll();
      }

      function handlePointerUp() {
        if (!isPointerDown) return;
        isPointerDown = false;
        pauseTemporarily(2600);
        scheduleScrollEnd(180);
      }

      function handlePointerIntent() {
        keyboardInteraction = false;
        isFocused = false;
      }

      function handleViewportPointerDown() {
        if (isManualScrolling) {
          window.cancelAnimationFrame(manualAnimationFrame);
          manualAnimationFrame = 0;
          isManualScrolling = false;
          moveQueue.length = 0;
          viewport.classList.remove('is-manual-moving');
          normalizeLoopPosition();
        }

        isPointerDown = true;
        stopAnimation();
      }

      function handleWheel() {
        if (isManualScrolling) {
          window.cancelAnimationFrame(manualAnimationFrame);
          manualAnimationFrame = 0;
          isManualScrolling = false;
          moveQueue.length = 0;
          viewport.classList.remove('is-manual-moving');
          normalizeLoopPosition();
        }

        keyboardInteraction = false;
        isFocused = false;
        pauseTemporarily(2600);
      }

      function handleKeyDown(event) {
        if (event.key !== 'Tab' && event.key.indexOf('Arrow') !== 0) return;

        keyboardInteraction = true;

        if (reviewsSection.contains(document.activeElement)) {
          isFocused = true;
          stopAnimation();
        }
      }

      function handleVisibilityChange() {
        if (document.hidden) {
          stopAnimation();
        } else {
          startAnimation();
        }
      }

      function handleMotionChange() {
        if (reducedMotion.matches) {
          if (isManualScrolling) finishManualMove();
          stopAnimation();
        } else {
          startAnimation();
        }
      }

      function cleanup(event) {
        if (event.target !== reviewsSection && !event.target.contains(reviewsSection)) return;

        stopAnimation();
        window.clearTimeout(resumeTimer);
        window.clearTimeout(scrollEndTimer);
        window.cancelAnimationFrame(manualAnimationFrame);
        window.cancelAnimationFrame(normalizationFrame);
        window.removeEventListener('pointerup', handlePointerUp);
        window.removeEventListener('pointercancel', handlePointerUp);
        window.removeEventListener('resize', measureLoop);
        document.removeEventListener('keydown', handleKeyDown);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        document.removeEventListener('shopify:section:unload', cleanup);

        if (reducedMotion.removeEventListener) {
          reducedMotion.removeEventListener('change', handleMotionChange);
        }

        if (resizeObserver) resizeObserver.disconnect();
        if (visibilityObserver) visibilityObserver.disconnect();
        clones.forEach(function (clone) {
          clone.remove();
        });
      }

      previous.addEventListener('click', function () {
        move(-1);
      });

      next.addEventListener('click', function () {
        move(1);
      });

      viewport.addEventListener('scroll', handleScroll, { passive: true });
      viewport.addEventListener('scrollend', handleScrollEnd);
      viewport.addEventListener('wheel', handleWheel, { passive: true });

      viewport.addEventListener('pointerenter', function () {
        isHovered = true;
        stopAnimation();
      });

      viewport.addEventListener('pointerleave', function () {
        isHovered = false;
        startAnimation();
      });

      reviewsSection.addEventListener('focusin', function () {
        isFocused = keyboardInteraction;

        if (isFocused) stopAnimation();
      });

      reviewsSection.addEventListener('focusout', function () {
        window.setTimeout(function () {
          isFocused = keyboardInteraction && reviewsSection.contains(document.activeElement);
          startAnimation();
        }, 0);
      });

      reviewsSection.addEventListener('pointerdown', handlePointerIntent);
      viewport.addEventListener('pointerdown', handleViewportPointerDown);

      window.addEventListener('pointerup', handlePointerUp);
      window.addEventListener('pointercancel', handlePointerUp);
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('visibilitychange', handleVisibilityChange);
      document.addEventListener('shopify:section:unload', cleanup);

      if (reducedMotion.addEventListener) {
        reducedMotion.addEventListener('change', handleMotionChange);
      }

      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(measureLoop);
        resizeObserver.observe(viewport);
      } else {
        window.addEventListener('resize', measureLoop);
      }

      if ('IntersectionObserver' in window) {
        visibilityObserver = new IntersectionObserver(function (entries) {
          isVisible = entries[0].isIntersecting;

          if (isVisible) {
            startAnimation();
          } else {
            stopAnimation();
          }
        }, { threshold: 0.12 });
        visibilityObserver.observe(reviewsSection);
      } else {
        isVisible = true;
      }

      measureLoop();
      startAnimation();
    }

    function initializeWithin(root) {
      if (root.matches && root.matches('[data-malvice-reviews]')) {
        initializeReviews(root);
      }

      if (root.querySelectorAll) {
        root.querySelectorAll('[data-malvice-reviews]').forEach(initializeReviews);
      }
    }

    initializeWithin(document);

    document.addEventListener('shopify:section:load', function (event) {
      initializeWithin(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
